import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import { ReactComponent as EditIcon } from '../../../assets/edit.svg';
import { ReactComponent as TruckIcon } from '../../../assets/truck.svg';
import { ReactComponent as DuplicateIcon } from '../../../assets/duplicate.svg';
import { ReactComponent as SaveIcon } from '../../../assets/savepdf.svg';
import { ReactComponent as CreateBill } from '../../../assets/billing.svg';
import { ReactComponent as ArchiveIcon } from '../../../assets/archive.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/delete.svg';

import { TwLoadMenuOptions } from '../TwLoadMenu';

const StyledBox = styled(Box)(() => ({
  backgroundColor: '#fff'
}));

const Puller = styled(Box)(() => ({
  width: '40px',
  height: '4px',
  backgroundColor: '#E5E5E5',
  borderRadius: '4px',
  position: 'absolute',
  top: '20px',
  left: 'calc(50% - 20px)'
}));

interface MobileLoadMenuProps {
  open: boolean;
  options: TwLoadMenuOptions[];
  onClose: (e: React.MouseEvent<HTMLElement>) => void;
  onOpen: () => void;
}

const MobileLoadMenu: FC<MobileLoadMenuProps> = ({ open, options, onClose, onOpen }) => {
  const menuItems = options.map((option, index) => {
    const labelClasses = option.label === 'Delete' ? 'tw-load-menu__delete' : 'tw-load-menu__label';

    return (
      <MenuItem
        key={index}
        onClick={(e): void => {
          option.action && option.action();
          onClose(e);
          e.stopPropagation();
        }}
      >
        <ListItemIcon>
          {option.label === 'Edit' && <EditIcon className="tw-load-menu__icon" />}
          {option.label === 'Send to driver' && <TruckIcon className="tw-load-menu__icon" />}
          {option.label === 'Save as PDF' && <SaveIcon className="tw-load-menu__icon" />}
          {option.label === 'Send invoice' && <CreateBill className="tw-load-menu__icon" />}
          {option.label === 'View invoice' && <CreateBill className="tw-load-menu__icon" />}
          {option.label === 'Duplicate' && <DuplicateIcon className="tw-load-menu__icon" />}
          {option.label === 'Archive' && <ArchiveIcon className="tw-load-menu__icon" />}
          {option.label === 'Delete' && <DeleteIcon className="tw-load-menu__icon" />}
        </ListItemIcon>
        <ListItemText className={labelClasses}>{option.label}</ListItemText>
      </MenuItem>
    );
  });

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      disableSwipeToOpen
      onClose={onClose}
      onOpen={onOpen}
      PaperProps={{
        sx: {
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px'
        }
      }}
    >
      <StyledBox
        sx={{
          paddingTop: '56px',
          paddingBottom: '22px',
          paddingLeft: '11px',
          paddingRight: '11px',
          height: '100%',
          overflow: 'auto'
        }}
        onClick={(e): void => {
          e.stopPropagation();
        }}
      >
        <Puller />
        <MenuList className="tw-load-menu__list">{menuItems}</MenuList>
      </StyledBox>
    </SwipeableDrawer>
  );
};

export default MobileLoadMenu;
